export default {
  showButton: false,
  isWhitelist: false, // 是否显示弹框
  isWhiteListFlag: true,
  isOpen: 1, // 是否开启白名单 1-开启 2-关闭
  isWatch_type: 1, // 开启位置 1-访问详情页 2-点击播放
  can_get_card: 0,
  isSchedule: false
}
